<template>
  <div class="text-blue-950">
    <div class="mb-6 text-3xl font-light lg:text-5xl">{{ $t('inquiryForm.stepOne.title') }}</div>
    <div class="mb-6">
      <span class="mb-3 inline-block text-base lg:mb-6 lg:text-xl">{{
        $t('inquiryForm.stepOne.selectMaterial')
      }}</span>
      <div class="grid-default !gap-4">
        <InquiryCheckbox
          v-for="(category, index) in updatedCategories"
          :id="`category-${index}`"
          :key="index"
          v-model="state.category"
          name="category"
          :value-by="category.programCategory!"
          class="col-span-3 lg:col-span-6 xl:col-span-3"
          :title="category.name!"
          :description="category.description!"
          @update:model-value="state.product = ''"
        />

        <InquiryCheckbox
          id="category-other"
          v-model="state.category"
          :value-by="otherMaterial.title"
          name="category"
          class="col-span-3 lg:col-span-6 xl:col-span-3"
          :title="otherMaterial.title"
          :description="otherMaterial.description"
          @update:model-value="state.product = ''"
        />
      </div>
    </div>

    <Transition name="fade">
      <div v-if="state.category">
        <span class="mb-3 inline-block text-base lg:mb-6 lg:text-xl">{{
          $t('inquiryForm.stepOne.selectProduct')
        }}</span>
        <div class="grid-default !gap-4">
          <InquiryCheckbox
            v-for="(product, index) in store.getProductsByCategory(state.category)"
            :id="`product-${index}`"
            :key="index"
            v-model="state.product"
            name="product"
            :value-by="product.product!"
            class="col-span-3 lg:col-span-6 xl:col-span-3"
            :title="product.product"
          />

          <InquiryCheckbox
            id="product-other"
            v-model="state.product"
            :value-by="otherMaterial.title!"
            name="product"
            class="col-span-3 lg:col-span-6 xl:col-span-3"
            :title="otherMaterial.title"
          />
        </div>
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import { InquiryProductDetails } from '~/types/inquiry'
import { useInquiryStore } from '~/stores/InquiryStore'
import { DatoCmsCategoryId } from '~/types/categories'

const { t } = useI18n()
const store = useInquiryStore()
const emit = defineEmits(['update:modelValue'])
const props = defineProps({
  modelValue: {
    type: Object as PropType<InquiryProductDetails>,
    required: true
  }
})

const state = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
})

const CATEGORIES = [
  {
    id: DatoCmsCategoryId.KOVINARSKI,
    name: t('inquiryForm.categories.metal')
  },
  {
    id: DatoCmsCategoryId.GRADBENI,
    name: t('inquiryForm.categories.buildingMaterials')
  },
  {
    id: DatoCmsCategoryId.LESNI,
    name: t('inquiryForm.categories.wood')

  }
]

// Solution for custom category names
const updatedCategories = computed(() => CATEGORIES.map(category1 => {
  const matchingCategory2 = store.categories.find(category2 => category2.id === category1.id)
  return {
    id: category1.id,
    description: matchingCategory2?.description,
    programCategory: matchingCategory2?.programCategory,
    name: category1.name
  }
}))

const otherMaterial = {
  title: t('inquiryForm.stepOne.otherTitle'),
  description: t('inquiryForm.stepOne.otherDescription')
}
</script>
